export const baseUrl = "https://acc-api.aptinstall.de"

export const BackendEndpointSessions = `${baseUrl}/sessions`;
export const BackendEndpointSession = `${baseUrl}/session`;

